import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface TicketOcrVerifyDialogProps {
  open: boolean;
  onClose: () => void;
  ocrSucceeded?: boolean;
}

const TicketOcrVerifyDialog: React.FC<TicketOcrVerifyDialogProps> = ({
  open,
  onClose,
  ocrSucceeded = true,
}) => (
  <Dialog
    open={open}
    onClose={(_, reason) => {
      if (reason === 'backdropClick') {
        return;
      }
      onClose();
    }}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>Please review your ticket details</DialogTitle>
    <DialogContent>
      <DialogContentText>
        We read your ticket automatically, but the results may not be accurate.
        Please confirm the ticket number, citation, address, city, county, court
        date, and license type before continuing.
      </DialogContentText>
      {!ocrSucceeded && (
        <DialogContentText sx={{ mt: 2 }}>
          We could not read all details from your image. Some fields may be
          empty and need to be entered manually.
        </DialogContentText>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained">
        Okay
      </Button>
    </DialogActions>
  </Dialog>
);

export default TicketOcrVerifyDialog;
